<div class="copo-grid">
	<div class="copo-grid-row">
		<div class="copo-grid-row-column">
			<mat-form-field class="copo-form-field">
				<mat-label translate>eoffer-Period.type</mat-label>
				<mat-select [(value)]="selectedPeriodType" (selectionChange)="onPeriodTypeChange($event.value)">
					<mat-option *ngFor="let type of periodTypes" [value]="type.value">
						{{ type.label | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="copo-grid-row-column"
			*ngIf="dynamicDropdownValues.length > 0 && selectedPeriodType !== 'Custom Period'">
			<mat-form-field class="copo-form-field">
				<mat-label translate>eoffer-Period.label</mat-label>
				<mat-select [(value)]="selectedDynamicValue" (selectionChange)="onDynamicValueChange($event.value)">
					<mat-select-trigger>
						{{ selectedDynamicValue ? formatPeriodValue(selectedDynamicValue) : '' }}
					</mat-select-trigger>
					<ng-container *ngIf="selectedPeriodType === 'Annually'; else groupedOptions">
						<mat-option *ngFor="let value of dynamicDropdownValues[0]?.values" [value]="value.value">
							{{ value.label }}
						</mat-option>
					</ng-container>
					<ng-template #groupedOptions>
						<mat-optgroup *ngFor="let group of dynamicDropdownValues" [label]="group.year">
							<mat-option *ngFor="let value of group.values" [value]="value.value">
								{{ value.label }}
							</mat-option>
						</mat-optgroup>
					</ng-template>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="copo-grid-row-column" *ngIf="selectedPeriodType !== 'Custom Period'">
			<p class="selected-period-display">
				<span translate>eoffer-selected.period</span>:
				<b>{{ selectedPeriodDisplay }}</b>
			</p>
		</div>
	</div>

	<div class="copo-grid-row" *ngIf="selectedPeriodType === 'Custom Period'">
		<div class="copo-grid-row-column">
			<mat-form-field class="copo-form-field">
				<mat-label translate>eoffer-From.month</mat-label>
				<mat-select [(value)]="fromMonth" (selectionChange)="onCustomPeriodChange()">
					<mat-select-trigger>
						{{ fromMonth ? formatPeriodValue(fromMonth) : '' }}
					</mat-select-trigger>
					<ng-container *ngFor="let group of dynamicDropdownValuesFrom">
						<mat-optgroup [label]="group.year">
							<mat-option *ngFor="let month of group.values" [value]="month.value">
								{{ month.label }}
							</mat-option>
						</mat-optgroup>
					</ng-container>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="copo-grid-row-column">
			<mat-form-field class="copo-form-field">
				<mat-label translate>eoffer-To.month</mat-label>
				<mat-select [(value)]="toMonth" (selectionChange)="onCustomPeriodChange()">
					<mat-select-trigger>
						{{ toMonth ? formatPeriodValue(toMonth) : '' }}
					</mat-select-trigger>
					<ng-container *ngFor="let group of dynamicDropdownValuesTo">
						<mat-optgroup [label]="group.year">
							<mat-option *ngFor="let month of group.values" [value]="month.value">
								{{ month.label }}
							</mat-option>
						</mat-optgroup>
					</ng-container>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="copo-grid-row-column">
			<p class="selected-period-display">
				<span translate>eoffer-selected.period</span>:
				<b>{{ selectedPeriodDisplay }}</b>
			</p>
		</div>
	</div>

</div>